export default __webpack_public_path__ + "static/media/forgot-reset-password-background.b0d2a985.jpg";